import React from 'react';
import PropTypes from 'prop-types';
import { compose, formatDate } from '../../../../services/utilityFunctions';
import translate from '../../../../commonComponents/translate';
import UserProp from '../../../../commonComponents/propTypes/userProp';

const LevelSection = props => {
  const { label, icon, value, date, wrapperClass } = props;
  return (
    <div className={`forecast-card-container ${wrapperClass}`}>
      <div className="forecast-card">
        <div className="forecast-info">
          <h6 className="forecast-level">{label}</h6>
          <div className="forecast-icon">
            <img src={icon || ''} alt="" />
          </div>
          <span className="forecast-value">{value}</span>
        </div>
        {date ? <h6 className="forecast-date">{`(${date})`}</h6> : null}
      </div>
    </div>
  );
};

LevelSection.propTypes = {
  label: PropTypes.string,
  date: PropTypes.string,
  icon: PropTypes.string,
  value: PropTypes.string,
  wrapperClass: PropTypes.string,
};

LevelSection.defaultProps = {
  label: '',
  date: '',
  icon: null,
  value: '',
  wrapperClass: '',
};

const LevelCard = ({ t, directSellingActive, user }) => {
  const { skillLevel, type, forecast, skillMaxLevel, maxLevel } = user;

  const { icon, name } = skillLevel || {};
  const { skillLevel: skillForecast, date, level } = forecast || {};
  const { icon: maxLevelIcon, name: maxLevelName } = skillMaxLevel || {};

  const { icon: iconForecast, name: nameForecast } = skillForecast || {};

  const shouldSeeForecast = type === 'collaborator' && directSellingActive;

  // Forecast
  const forecastDate = date
    ? formatDate(date, 'DD MMM YYYY')
    : `(${t('profile.sidePanel.level.noForecastDate')})`;

  // if level === 0 and not exist skillForecast show (No level)
  const forecastLevelName =
    level === null && !skillForecast
      ? t('connect.teams.structure.no_level')
      : nameForecast;

  const forecastDateText = `${t(
    'profile.sidePanel.level.forecastDate',
  )}: ${forecastDate}`;

  // if empty not show
  const emptyForecast = !date && !skillForecast && level < 0;

  return (
    <div className="level-card">
      <div className="level-info-container">
        <div className="level-icon">
          <div className="level-icon-wrapper">
            <img src={icon || ''} alt="" />
          </div>
        </div>
        <div className="level-info">
          <p className="label-level">{`${t(
            'profile.sidePanel.level.label',
          )}:`}</p>
          <h2 className="level-user">
            {name || t('connect.teams.structure.no_level')}
          </h2>
        </div>
      </div>
      {shouldSeeForecast && !emptyForecast && (
        <LevelSection
          label={`${t('profile.sidePanel.level.forecastLevel')}:`}
          value={forecastLevelName}
          icon={iconForecast}
          date={forecastDateText}
          wrapperClass="forecastLevelWrapper"
        />
      )}
      {maxLevel && maxLevel > 0 ? (
        <LevelSection
          label={`${t('user.highest.level')}:`}
          value={maxLevelName}
          icon={maxLevelIcon}
          wrapperClass="highestLevelWrapper"
        />
      ) : null}
    </div>
  );
};

LevelCard.propTypes = {
  t: PropTypes.func.isRequired,
  directSellingActive: PropTypes.bool.isRequired,
  user: PropTypes.shape(UserProp.propType).isRequired,
};

export default compose(translate)(LevelCard);
